import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import LayoutMasterDetail from "layouts/LayoutMasterDetail";
import { StoreContext } from "shared/context/store-context";
import PersonelSchoolItem from "./PersonelSchoolItem";

const PersonelSchoolsList = () => {
  const { t } = useTranslation();
  const itemType = "personelSchoolItem";
  const listName = "main_personel_schools";

  const { personelSchools, DeleteSchool, InsertSchool, UpdateSchool } = useContext(StoreContext);

  const pageItems = personelSchools;

  let listColumns = [];
  listColumns.push({ field: "name", headerName: t("name"), width: 400 });
  listColumns.push({ field: "tag", headerName: t("tag"), width: 200 });

  return (
    <LayoutMasterDetail
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={PersonelSchoolItem}
      NewItemComponent={PersonelSchoolItem}
      DeleteItem={DeleteSchool}
      InsertItem={InsertSchool}
      UpdateItem={UpdateSchool}
      hideCreateNewItemWhenSelected={true}
    />
  );
};

export default PersonelSchoolsList;
